import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export interface Props {
  isPending: boolean;
  errorMessage?: string;
  onClaim: (tokenString: string) => void;
}

export const LicenseClaim = ({ isPending, errorMessage, onClaim }: Props) => {
  const [t] = useTranslation();
  const [tokenString, setTokenString] = useState<string>("");

  async function claimClick() {
    onClaim(tokenString);
  }

  return (
    <Dialog
      open={true}
      PaperProps={{
        onSubmit: (event: React.FormEvent<HTMLDivElement>) => {
          event.preventDefault();
          claimClick();
        },
      }}
    >
      <form>
        <DialogTitle>{t("modals.licenseClaim.title")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("modals.licenseClaim.body")}</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            onChange={(e) => setTokenString(e.target.value)}
            label={t("modals.licenseClaim.tokenLabel")}
            value={tokenString}
            fullWidth
            variant="standard"
            disabled={isPending}
          />
          {errorMessage && (
            <Typography variant="body2" color="error">
              {errorMessage}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button type="submit" disabled={isPending}>
            {t("modals.licenseClaim.continue")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
